module.exports = __webpack_public_path__ + "img/grid-3x2-gap-fill.c5a053ef.svg";